import { LegalFooter } from "./footer";
import { STRINGS } from "../constants/strings";

interface Props {
  error: string | null;
}

export function ConfirmStatusView({ error }: Props) {
  return (
    <div class="tl-page">
      <div class="tl-page-centered">
        {error ? (
          <span class="tl-field__error" role="alert">
            {error}
          </span>
        ) : (
          <p>{STRINGS.loading}</p>
        )}
      </div>
      <LegalFooter />
    </div>
  );
}
